export enum LLPType {
    OneRate = 'oneRate',
    TwoRates = 'twoRates',
    ThreeRates = 'threeRates'
}
